import React from 'react';

import { PAGE_TITLE } from '../../constants';
import Component from '../../components/depositolog';
import Container from '../../containers/admin';
import Root from '../../components/root';

export default function PageDepositos() {
  return (
    <Root title={PAGE_TITLE.DEPOSITOS}>
      <Container>
        <Component/>
      </Container>
    </Root>
  );
};
